// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InfoPopup_tip__RWdi\\+ {
    display: inline-flex;
    position: relative;
    /*z-index: 9;*/
    justify-content: center;
}

.InfoPopup_tipBtn__5s\\+1l {
    background: transparent;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: 0;
    color: #000000;
    font-size: inherit;
    margin: auto;
}

.InfoPopup_tipBtn__5s\\+1l:hover {
    background: transparent;
}

.InfoPopup_tipBtnImg__3pAyL {
    position: relative;
    display: inline-flex;
    margin-top: 4px;
    /*width: 20px;*/
}

.InfoPopup_tipBtn__5s\\+1l img:last-child {
    position: absolute;
    bottom: 0;
    opacity: 0;
}

.InfoPopup_tipBtn__5s\\+1l img {
    width: 20px;
    transition: opacity 0.4s;
}

.InfoPopup_tipBtn__5s\\+1l span:first-letter {
    text-transform: capitalize;
}

.InfoPopup_tip__RWdi\\+:hover img {
    opacity: 1;
}

.InfoPopup_tip__RWdi\\+:hover svg text {
    fill: #fff;
}

.InfoPopup_tip__RWdi\\+:hover .InfoPopup_tipBox__Q-RZy {
    opacity: 1;
    pointer-events: all;
    z-index: 14;
}

.InfoPopup_tipBox__Q-RZy {
    position: absolute;
    width: 175px;
    background: #7b848e;
    padding: 20px;
    /*box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);*/
    color: #fff;
    font-size: 14px;
    line-height: 18px;
    margin: auto;
    left: 50%;
    transform: translateX(-50%);
    bottom: 24px;
    opacity: 0;
    transition: opacity 0.4s;
    pointer-events: none;
    max-height: 300px;
    overflow: auto;
    z-index: -1;
    border-radius: 3px;
}

.InfoPopup_tipBox__Q-RZy:first-letter {
    text-transform: capitalize;
}
`, "",{"version":3,"sources":["webpack://./src/components/InfoPopup/InfoPopup.module.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,SAAS;IACT,cAAc;IACd,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,6CAA6C;IAC7C,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,YAAY;IACZ,UAAU;IACV,wBAAwB;IACxB,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":[".tip {\n    display: inline-flex;\n    position: relative;\n    /*z-index: 9;*/\n    justify-content: center;\n}\n\n.tipBtn {\n    background: transparent;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    border: 0;\n    color: #000000;\n    font-size: inherit;\n    margin: auto;\n}\n\n.tipBtn:hover {\n    background: transparent;\n}\n\n.tipBtnImg {\n    position: relative;\n    display: inline-flex;\n    margin-top: 4px;\n    /*width: 20px;*/\n}\n\n.tipBtn img:last-child {\n    position: absolute;\n    bottom: 0;\n    opacity: 0;\n}\n\n.tipBtn img {\n    width: 20px;\n    transition: opacity 0.4s;\n}\n\n.tipBtn span:first-letter {\n    text-transform: capitalize;\n}\n\n.tip:hover img {\n    opacity: 1;\n}\n\n.tip:hover svg text {\n    fill: #fff;\n}\n\n.tip:hover .tipBox {\n    opacity: 1;\n    pointer-events: all;\n    z-index: 14;\n}\n\n.tipBox {\n    position: absolute;\n    width: 175px;\n    background: #7b848e;\n    padding: 20px;\n    /*box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);*/\n    color: #fff;\n    font-size: 14px;\n    line-height: 18px;\n    margin: auto;\n    left: 50%;\n    transform: translateX(-50%);\n    bottom: 24px;\n    opacity: 0;\n    transition: opacity 0.4s;\n    pointer-events: none;\n    max-height: 300px;\n    overflow: auto;\n    z-index: -1;\n    border-radius: 3px;\n}\n\n.tipBox:first-letter {\n    text-transform: capitalize;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tip": `InfoPopup_tip__RWdi+`,
	"tipBtn": `InfoPopup_tipBtn__5s+1l`,
	"tipBtnImg": `InfoPopup_tipBtnImg__3pAyL`,
	"tipBox": `InfoPopup_tipBox__Q-RZy`
};
export default ___CSS_LOADER_EXPORT___;
